// extracted by mini-css-extract-plugin
export var container = "_sk-0";
export var dotAnimation = "_sk-2";
export var dotsLoading = "_sk-1";